import { request } from '@umijs/max';

// 客户消息数量查询参数
export interface CustomerCountQueryDto {
    order_nos: string[];
}

// 客户消息数量响应
export interface CustomerCountResponseDto {
    order_no: string; // 订单号
    customer_count: number; // 该订单聊天室中的客户消息总数
}

// 获取聊天室列表
export async function getChatRoomList(
    params: API.ChatRoomSearchParams,
    options?: { [key: string]: any },
) {
    return request<API.ChatRoomListResult>('/chat-room', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}


// 获取聊天室列表
export async function getChatRoomSimpleList(
    params: API.ChatRoomSearchParams,
    options?: { [key: string]: any },
) {
    return request<API.ChatRoomListResult>('/chat-room/simple', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}

// 获取客户消息数量
export async function getCustomerCount(
    data: CustomerCountQueryDto,
    options?: { [key: string]: any },
) {
    return request<API.StandardResponse<CustomerCountResponseDto[]>>('/chat-room/customer-count', {
        method: 'POST',
        data,
        ...(options || {}),
    });
} 